import React, { useState, useEffect } from 'react';
import { FaShoppingCart, FaHeart as EmptyHeart, FaStar } from 'react-icons/fa';
import { FaHeart as FilledHeart } from 'react-icons/fa6';
import { MdOutlineLocalShipping } from "react-icons/md";
import { BsArrowRepeat } from "react-icons/bs";
import { HiOutlineShoppingBag } from "react-icons/hi";
import Lottie from 'lottie-react';
import elevateMartPlaceholder from '../assets/image_loading.json';
import ReactPixel from 'react-facebook-pixel';
import slugify from 'slugify';
import { v4 as uuidv4 } from 'uuid';
import ReactGA from "react-ga4";

const ProductCard = ({ product, addToCart, toggleFavorite, isFavorite, cartItems, navigate }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const eventId = uuidv4();

  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);

    if (product.image) {
      const img = new Image();
      img.src = product.image;
      img.onload = () => setImageLoaded(true);
      img.onerror = () => setImageError(true);
    }
  }, [product]);

  const inCart = cartItems.some(item => item.id === (product.productId || product.id));

  const handleBuyNowClick = (e) => {
    e.stopPropagation();

    const productToAdd = {
      ...product,
      id: product.productId || product.id
    };

    addToCart(productToAdd);

    console.log(product);

    function getFbClickId() {
      const match = document.cookie.match(/_fbc=([^;]*)/);
      return match ? match[1] : null;
    }

    function getFbBrowserId() {
      const match = document.cookie.match(/_fbp=([^;]*)/);
      return match ? match[1] : null;
    }

    const externalId = localStorage.getItem('client_id');
    const fbc = getFbClickId();
    const fbp = getFbBrowserId();
    const eventTime = Math.floor(Date.now() / 1000);

    ReactGA.event('add_to_cart', {
      currency: 'BDT',
      value: product.price,
      items: [{
        item_id: product.productId || product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: 1
      }],
      event_id: eventId,
    });

    const userData = {
      fbc: fbc,
      fbp: fbp,
      external_id: externalId,
    };

    if (typeof window !== 'undefined' && window.fbq) {
      ReactPixel.track('AddToCart', {
        content_ids: [product.productId || product.id],
        content_name: product.name,
        content_category: product.category,
        currency: 'BDT',
        value: product.price,
        content_type: 'product',
        event_id: eventId,
      }, userData);

      fetch('https://aman-life-style-bd-main-server.sparkx-ai.shop/api/track-addtocart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          event_name: 'AddToCart',
          productId: product.productId || product.id,
          name: product.name,
          price: product.price,
          fbc: fbc,
          fbp: fbp,
          external_id: externalId,
          event_id: eventId,
          event_time: eventTime
        }),
      }).then(res => res.json())
        .then(data => console.log('AddToCart sent to Flask:', data))
        .catch(err => console.error('Error sending AddToCart to Flask:', err));
    }

    const cartItemForCheckout = {
      ...product,
      quantity: 1,
      selectedSize: product.sizes && product.sizes.length > 0 ? product.sizes[0] : null,
      selectedColor: product.colors && product.colors.length > 0 ? product.colors[0] : null,
    };

    if (navigate) {
      navigate('/checkout', {
        state: {
          cartItems: [cartItemForCheckout]
        }
      });
    }
  };

  const handleAddToCartClick = (e) => {
    e.stopPropagation();

    const productToAdd = {
      ...product,
      id: product.productId || product.id
    };

    addToCart(productToAdd);

    console.log(productToAdd);

    function getFbClickId() {
      const match = document.cookie.match(/_fbc=([^;]*)/);
      return match ? match[1] : null;
    }

    function getFbBrowserId() {
      const match = document.cookie.match(/_fbp=([^;]*)/);
      return match ? match[1] : null;
    }

    const externalId = localStorage.getItem('client_id');
    const fbc = getFbClickId();
    const fbp = getFbBrowserId();
    const eventTime = Math.floor(Date.now() / 1000);
    console.log(eventTime);

    ReactGA.event('add_to_cart', {
      currency: 'BDT',
      value: product.price,
      items: [{
        item_id: product.productId || product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: 1
      }],
      event_id: eventId,
    });

    const userData = {
      fbc: fbc,
      fbp: fbp,
      external_id: externalId,
    };

    if (typeof window !== 'undefined' && window.fbq) {
      console.log('Firing Facebook Pixel AddToCart event for product:', product.name);
      ReactPixel.track('AddToCart', {
        content_ids: [product.productId || product.id],
        content_name: product.name,
        content_category: product.category,
        currency: 'BDT',
        value: product.price,
        content_type: 'product',
        event_id: eventId,
      }, userData);

      fetch('https://aman-life-style-bd-main-server.sparkx-ai.shop/api/track-addtocart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          event_name: 'AddToCart',
          productId: product.productId || product.id,
          name: product.name,
          price: product.price,
          fbc: fbc,
          fbp: fbp,
          external_id: externalId,
          event_id: eventId,
          event_time: eventTime
        }),
      }).then(res => res.json())
        .then(data => console.log('AddToCart sent to Flask:', data))
        .catch(err => console.error('Error sending AddToCart to Flask:', err));
    } else {
      console.warn('Facebook Pixel: AddToCart event not fired. fbq object is not available.');
    }
  };

  const handleCardClick = () => {
    const titleSlug = slugify(product.name, {
      lower: true,
      strict: true,
      trim: true
    });
    if (navigate) {
      navigate(`/product/${product.productId || product.id}/${titleSlug}`);
    }
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    toggleFavorite(product.id);

    if (!isFavorite(product.id)) {
      if (typeof window !== 'undefined' && window.fbq) {
        console.log('Firing Facebook Pixel AddToWishlist event for product:', product.name);
        ReactPixel.track('AddToWishlist', {
          content_ids: [product.id],
          content_name: product.name,
          currency: 'BDT',
          value: product.price,
          content_type: 'product',
        });
      } else {
        console.warn('Facebook Pixel: AddToWishlist event not fired. fbq object is not available.');
      }
    }
  };

  const isLowStock = product.stock <= 10 && product.stock > 0;
  const isOutOfStock = product.stock === 0;

  const averageRating = product.reviews?.length > 0
    ? (product.reviews.reduce((acc, r) => acc + r.rating, 0) / product.reviews.length)
    : 0;

  const totalReviews = product.reviews?.length || 0;

  return (
    <div
      onClick={handleCardClick}
      className="bg-white rounded-2xl cursor-pointer flex flex-col h-full relative overflow-hidden group"
      style={{
        fontFamily: "'Assistant', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        boxShadow: '0 1px 4px rgba(0,0,0,0.07), 0 4px 16px rgba(0,0,0,0.06)',
        transition: 'box-shadow 0.25s ease, transform 0.25s ease',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.13), 0 2px 8px rgba(0,0,0,0.08)';
        e.currentTarget.style.transform = 'translateY(-3px)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.07), 0 4px 16px rgba(0,0,0,0.06)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      {/* ── Image Area ── */}
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: '1 / 1', background: '#f7f7f9' }}>

        {/* Badges */}
        {product.discount && (
          <div
            className="absolute top-2.5 left-2.5 z-10 text-white text-[10px] md:text-xs font-bold px-2.5 py-1 rounded-full"
            style={{ background: 'linear-gradient(135deg, #e53935, #c62828)', letterSpacing: '0.03em', boxShadow: '0 2px 6px rgba(229,57,53,0.35)' }}
          >
            {product.discount}
          </div>
        )}
        {product.isPopular && (
          <div
            className={`absolute top-2.5 z-10 text-white text-[10px] md:text-xs font-bold px-2.5 py-1 rounded-full ${product.discount ? 'right-12' : 'right-2.5'}`}
            style={{ background: 'linear-gradient(135deg, #fb8c00, #e65100)', letterSpacing: '0.03em', boxShadow: '0 2px 6px rgba(251,140,0,0.35)' }}
          >
            🔥 Popular
          </div>
        )}

        {/* Favorite */}
        <button
          onClick={handleFavoriteClick}
          className="absolute top-2.5 right-2.5 z-20 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-white transition-all duration-200"
          style={{ boxShadow: '0 1px 6px rgba(0,0,0,0.13)', fontSize: '1rem' }}
        >
          {isFavorite(product.id)
            ? <FilledHeart style={{ color: '#e53935' }} />
            : <EmptyHeart style={{ color: '#bbb' }} />}
        </button>

        {/* Product Image */}
        {!imageLoaded && !imageError ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <Lottie animationData={elevateMartPlaceholder} loop autoplay style={{ width: 80, height: 80 }} />
          </div>
        ) : (
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover"
            style={{ transform: 'rotate(90deg)', transition: 'transform 0.35s ease' }}
          />
        )}

        {/* Out-of-stock overlay */}
        {isOutOfStock && (
          <div className="absolute inset-0 flex items-center justify-center" style={{ background: 'rgba(255,255,255,0.6)', backdropFilter: 'blur(2px)' }}>
            <span className="text-xs md:text-sm font-bold text-red-600 border border-red-400 px-3 py-1 rounded-full bg-white">Out of Stock</span>
          </div>
        )}
      </div>

      {/* ── Card Body ── */}
      <div className="flex flex-col flex-grow px-3 pt-3 pb-3 md:px-4 md:pt-4 md:pb-4" style={{ gap: '6px' }}>

        {/* Product Name */}
        <h3
          className="text-gray-900 line-clamp-2 leading-snug"
          style={{
            fontFamily: "'Assistant', sans-serif",
            fontSize: 'clamp(12px, 2.5vw, 14px)',
            fontWeight: 500,
            letterSpacing: '-0.01em',
            minHeight: '2.6em',
            marginBottom: '2px',
          }}
        >
          {product.name}
        </h3>

        {/* Price Row */}
        <div className="flex items-center gap-2" style={{ marginTop: '2px' }}>
          <span style={{ fontSize: 'clamp(15px, 3vw, 18px)', fontWeight: 700, color: '#111', letterSpacing: '-0.02em' }}>
            ৳{product.price}
          </span>
          {product.originalPrice && (
            <span style={{ fontSize: 'clamp(11px, 2vw, 13px)', color: '#aaa', textDecoration: 'line-through' }}>
              ৳{product.originalPrice}
            </span>
          )}
        </div>

        {/* Low Stock */}
        {!isOutOfStock && isLowStock && (
          <p style={{ fontSize: '11px', color: '#e53935', fontWeight: 600, marginTop: '0px' }}>
            ⚡ Only {product.stock} left!
          </p>
        )}

        {/* Sold count */}
        <div
          className="flex items-center gap-1"
          style={{ fontSize: '11px', color: '#888', paddingTop: '6px', borderTop: '1px solid #f0f0f0', marginTop: '2px' }}
        >
          <HiOutlineShoppingBag style={{ fontSize: '13px' }} />
          <span style={{ fontWeight: 600 }}>{product.buyers} Sold</span>
        </div>

        {/* ── Buttons ── */}
        <div className="flex gap-2 mt-auto pt-2">
          {/* Add to Cart */}
          <button
            onClick={handleAddToCartClick}
            disabled={isOutOfStock}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              padding: 'clamp(6px, 1vw, 9px) clamp(6px, 1vw, 10px)',
              borderRadius: '0px',
              fontSize: 'clamp(9px, 1.2vw, 12px)',
              fontWeight: 700,
              border: '2px solid #1a1a1a',
              cursor: isOutOfStock ? 'not-allowed' : 'pointer',
              transition: 'all 0.18s ease',
              background: isOutOfStock ? '#e0e0e0' : inCart ? '#1a1a1a' : 'transparent',
              color: isOutOfStock ? '#999' : inCart ? '#fff' : '#1a1a1a',
              boxShadow: 'none',
              letterSpacing: '0.02em',
            }}
            onMouseEnter={e => { if (!isOutOfStock) { e.currentTarget.style.background = '#1a1a1a'; e.currentTarget.style.color = '#fff'; } }}
            onMouseLeave={e => { if (!isOutOfStock && !inCart) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#1a1a1a'; } }}
          >
            {isOutOfStock ? 'Out of Stock' : (
              <>
                <FaShoppingCart style={{ fontSize: '12px' }} />
                <span>{inCart ? 'In Cart' : 'Add'}</span>
              </>
            )}
          </button>

          {/* Buy Now */}
          <button
            onClick={handleBuyNowClick}
            disabled={isOutOfStock}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              padding: 'clamp(6px, 1vw, 9px) clamp(6px, 1vw, 10px)',
              borderRadius: '0px',
              fontSize: 'clamp(9px, 1.2vw, 12px)',
              fontWeight: 700,
              border: '2px solid #1a1a1a',
              cursor: isOutOfStock ? 'not-allowed' : 'pointer',
              transition: 'all 0.18s ease',
              background: isOutOfStock ? '#e0e0e0' : '#1a1a1a',
              color: isOutOfStock ? '#999' : '#fff',
              boxShadow: 'none',
              letterSpacing: '0.02em',
            }}
            onMouseEnter={e => { if (!isOutOfStock) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#1a1a1a'; } }}
            onMouseLeave={e => { if (!isOutOfStock) { e.currentTarget.style.background = '#1a1a1a'; e.currentTarget.style.color = '#fff'; } }}
          >
            {isOutOfStock ? 'Out of Stock' : (
              <>
                <FaShoppingCart style={{ fontSize: '12px' }} />
                <span>Buy Now</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
